import _createClass from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

export var WalletError = /*#__PURE__*/function (_Error) {
  _inherits(WalletError, _Error);

  var _super = _createSuper(WalletError);

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  function WalletError(message, error) {
    var _this;

    _classCallCheck(this, WalletError);

    _this = _super.call(this, message);
    _this.error = error;
    return _this;
  }

  return _createClass(WalletError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var WalletNotReadyError = /*#__PURE__*/function (_WalletError) {
  _inherits(WalletNotReadyError, _WalletError);

  var _super2 = _createSuper(WalletNotReadyError);

  function WalletNotReadyError() {
    var _this2;

    _classCallCheck(this, WalletNotReadyError);

    _this2 = _super2.apply(this, arguments);
    _this2.name = 'WalletNotReadyError';
    return _this2;
  }

  return _createClass(WalletNotReadyError);
}(WalletError);
export var WalletLoadError = /*#__PURE__*/function (_WalletError2) {
  _inherits(WalletLoadError, _WalletError2);

  var _super3 = _createSuper(WalletLoadError);

  function WalletLoadError() {
    var _this3;

    _classCallCheck(this, WalletLoadError);

    _this3 = _super3.apply(this, arguments);
    _this3.name = 'WalletLoadError';
    return _this3;
  }

  return _createClass(WalletLoadError);
}(WalletError);
export var WalletConfigError = /*#__PURE__*/function (_WalletError3) {
  _inherits(WalletConfigError, _WalletError3);

  var _super4 = _createSuper(WalletConfigError);

  function WalletConfigError() {
    var _this4;

    _classCallCheck(this, WalletConfigError);

    _this4 = _super4.apply(this, arguments);
    _this4.name = 'WalletConfigError';
    return _this4;
  }

  return _createClass(WalletConfigError);
}(WalletError);
export var WalletConnectionError = /*#__PURE__*/function (_WalletError4) {
  _inherits(WalletConnectionError, _WalletError4);

  var _super5 = _createSuper(WalletConnectionError);

  function WalletConnectionError() {
    var _this5;

    _classCallCheck(this, WalletConnectionError);

    _this5 = _super5.apply(this, arguments);
    _this5.name = 'WalletConnectionError';
    return _this5;
  }

  return _createClass(WalletConnectionError);
}(WalletError);
export var WalletDisconnectedError = /*#__PURE__*/function (_WalletError5) {
  _inherits(WalletDisconnectedError, _WalletError5);

  var _super6 = _createSuper(WalletDisconnectedError);

  function WalletDisconnectedError() {
    var _this6;

    _classCallCheck(this, WalletDisconnectedError);

    _this6 = _super6.apply(this, arguments);
    _this6.name = 'WalletDisconnectedError';
    return _this6;
  }

  return _createClass(WalletDisconnectedError);
}(WalletError);
export var WalletDisconnectionError = /*#__PURE__*/function (_WalletError6) {
  _inherits(WalletDisconnectionError, _WalletError6);

  var _super7 = _createSuper(WalletDisconnectionError);

  function WalletDisconnectionError() {
    var _this7;

    _classCallCheck(this, WalletDisconnectionError);

    _this7 = _super7.apply(this, arguments);
    _this7.name = 'WalletDisconnectionError';
    return _this7;
  }

  return _createClass(WalletDisconnectionError);
}(WalletError);
export var WalletAccountError = /*#__PURE__*/function (_WalletError7) {
  _inherits(WalletAccountError, _WalletError7);

  var _super8 = _createSuper(WalletAccountError);

  function WalletAccountError() {
    var _this8;

    _classCallCheck(this, WalletAccountError);

    _this8 = _super8.apply(this, arguments);
    _this8.name = 'WalletAccountError';
    return _this8;
  }

  return _createClass(WalletAccountError);
}(WalletError);
export var WalletPublicKeyError = /*#__PURE__*/function (_WalletError8) {
  _inherits(WalletPublicKeyError, _WalletError8);

  var _super9 = _createSuper(WalletPublicKeyError);

  function WalletPublicKeyError() {
    var _this9;

    _classCallCheck(this, WalletPublicKeyError);

    _this9 = _super9.apply(this, arguments);
    _this9.name = 'WalletPublicKeyError';
    return _this9;
  }

  return _createClass(WalletPublicKeyError);
}(WalletError);
export var WalletKeypairError = /*#__PURE__*/function (_WalletError9) {
  _inherits(WalletKeypairError, _WalletError9);

  var _super10 = _createSuper(WalletKeypairError);

  function WalletKeypairError() {
    var _this10;

    _classCallCheck(this, WalletKeypairError);

    _this10 = _super10.apply(this, arguments);
    _this10.name = 'WalletKeypairError';
    return _this10;
  }

  return _createClass(WalletKeypairError);
}(WalletError);
export var WalletNotConnectedError = /*#__PURE__*/function (_WalletError10) {
  _inherits(WalletNotConnectedError, _WalletError10);

  var _super11 = _createSuper(WalletNotConnectedError);

  function WalletNotConnectedError() {
    var _this11;

    _classCallCheck(this, WalletNotConnectedError);

    _this11 = _super11.apply(this, arguments);
    _this11.name = 'WalletNotConnectedError';
    return _this11;
  }

  return _createClass(WalletNotConnectedError);
}(WalletError);
export var WalletSendTransactionError = /*#__PURE__*/function (_WalletError11) {
  _inherits(WalletSendTransactionError, _WalletError11);

  var _super12 = _createSuper(WalletSendTransactionError);

  function WalletSendTransactionError() {
    var _this12;

    _classCallCheck(this, WalletSendTransactionError);

    _this12 = _super12.apply(this, arguments);
    _this12.name = 'WalletSendTransactionError';
    return _this12;
  }

  return _createClass(WalletSendTransactionError);
}(WalletError);
export var WalletSignMessageError = /*#__PURE__*/function (_WalletError12) {
  _inherits(WalletSignMessageError, _WalletError12);

  var _super13 = _createSuper(WalletSignMessageError);

  function WalletSignMessageError() {
    var _this13;

    _classCallCheck(this, WalletSignMessageError);

    _this13 = _super13.apply(this, arguments);
    _this13.name = 'WalletSignMessageError';
    return _this13;
  }

  return _createClass(WalletSignMessageError);
}(WalletError);
export var WalletSignTransactionError = /*#__PURE__*/function (_WalletError13) {
  _inherits(WalletSignTransactionError, _WalletError13);

  var _super14 = _createSuper(WalletSignTransactionError);

  function WalletSignTransactionError() {
    var _this14;

    _classCallCheck(this, WalletSignTransactionError);

    _this14 = _super14.apply(this, arguments);
    _this14.name = 'WalletSignTransactionError';
    return _this14;
  }

  return _createClass(WalletSignTransactionError);
}(WalletError);
export var WalletTimeoutError = /*#__PURE__*/function (_WalletError14) {
  _inherits(WalletTimeoutError, _WalletError14);

  var _super15 = _createSuper(WalletTimeoutError);

  function WalletTimeoutError() {
    var _this15;

    _classCallCheck(this, WalletTimeoutError);

    _this15 = _super15.apply(this, arguments);
    _this15.name = 'WalletTimeoutError';
    return _this15;
  }

  return _createClass(WalletTimeoutError);
}(WalletError);
export var WalletWindowBlockedError = /*#__PURE__*/function (_WalletError15) {
  _inherits(WalletWindowBlockedError, _WalletError15);

  var _super16 = _createSuper(WalletWindowBlockedError);

  function WalletWindowBlockedError() {
    var _this16;

    _classCallCheck(this, WalletWindowBlockedError);

    _this16 = _super16.apply(this, arguments);
    _this16.name = 'WalletWindowBlockedError';
    return _this16;
  }

  return _createClass(WalletWindowBlockedError);
}(WalletError);
export var WalletWindowClosedError = /*#__PURE__*/function (_WalletError16) {
  _inherits(WalletWindowClosedError, _WalletError16);

  var _super17 = _createSuper(WalletWindowClosedError);

  function WalletWindowClosedError() {
    var _this17;

    _classCallCheck(this, WalletWindowClosedError);

    _this17 = _super17.apply(this, arguments);
    _this17.name = 'WalletWindowClosedError';
    return _this17;
  }

  return _createClass(WalletWindowClosedError);
}(WalletError);